const getDefaultState = () => {
	return {
		propertyAddress: '',
		signingContractId: false,
		tenantForReview: {
			fullName: '',
			email: '',
			currentZipcode: '',
			currentCity: '',
			currentAddress: ''
		},
		landlordForReview: {
			fullName: '',
			email: '',
			currentZipcode: '',
			currentCity: '',
			currentAddress: '',
			bankRegNo: '',
			bankAccountNo: '',
			bankName: ''
		}
	}
}


const state = getDefaultState()

const getters = {
	getSigningPropertyAddress: (state) => state.propertyAddress,
	getSigningContractId: (state) => state.signingContractId,
	getSigningContractTenantForReview: (state) => state.tenantForReview,
	getSigningContractLandlordForReview: (state) => state.landlordForReview
}

const mutations = {
	resetSigningState: (state) => Object.assign(state, getDefaultState()),
	setSigningPropertyAddress: (state, address) => state.propertyAddress = address,
	setSigningContractId: (state, id) => state.signingContractId = id,
	setSigningContractTenantForReview: (state, tenant) => state.tenantForReview = tenant,
	setSigningContractLandlordForReview: (state, landlord) => state.landlordForReview = landlord
}

const actions = {
	async fetchContractForSignature({commit, getters}, id) {
		commit('setSigningPropertyAddress', 'Loading ...');
		await axios({
            method: 'GET',
            url: window.config.apiUrl + 'api/contract/'+id+'/signature-info',
			cancelToken: window.AuthorizationCancelSource.token,
        }).then(response => {
			commit('setSigningContractId', id);
			commit('setSigningPropertyAddress', response.data.address);
			commit('setSigningContractTenantForReview', response.data.tenantForReview);
			commit('setSigningContractLandlordForReview', response.data.landlordForReview);
        });
	}
}

export default {
    state,
    getters,
    mutations,
    actions
}
